import React from "react";
import Select from "react-select";
import { dashboardColors, theme } from "../../../themes/Theme";

const customStyles = {
	option: (styles, { isFocused, isSelected }) => ({
		...styles,
		background: isSelected ? dashboardColors[theme].primary : undefined,
		color: isSelected ? "white" : undefined,
		zIndex: 10,
		overflowX: "hidden",
		wordBreak: "break-word",
		display: "flex",
		alignItems: "center",
	}),
	menu: (provided) => ({
		...provided,
		marginTop: "2px",
		overflow: "hidden",
	}),
	menuPortal: (base) => ({ ...base, zIndex: 9999 }),
	dropdownIndicator: (base) => ({
		...base,
		color: dashboardColors[theme].primaryTextColor,
		padding: "5px 8px",
		"&:hover": {
			color: dashboardColors[theme].primaryTextColor,
		},
	}),
	control: (base, state) => ({
		...base,
		border: state.isFocused ? `1px solid ${dashboardColors[theme].primary}` : "1px solid #cdd4db",
		boxShadow: "none",
		borderRadius: "2px",
		minHeight: "36px",
	}),
};

const getOptionLabelWithImage = (option) => {
	if (option.icon || option.image) {
		return (
			<div className="d-flex aligns-items-center">
				{option.image && <img src={option.image} alt={option.label} className="labelWithImage"  />}
				{option.icon && <i className={`${option.icon} labelWithIcon`} ></i>} 
				{option.label}
			</div>
		);
	}
	return option.label;
};


const DropdownWithIcon = ({
	value,
	options,
	disabled,
	id,
	onChange,
	editable,
	placeholder,
	getOptionLabel,
	className,
	containerClass,
	menuShouldScrollIntoView = false
}) => {
	const filteredOptions = options.filter(option => option.value !== value?.value);

	return (
		<>
			<div className={containerClass || ""}>
				<Select
					isDisabled={disabled}
					id={id}
					name={id}
					value={value}
					onChange={onChange}
					placeholder={editable === "Edit" ? value : placeholder}
					className={id}
					styles={customStyles}
					options={filteredOptions} 
					getOptionLabel={getOptionLabel || getOptionLabelWithImage}
					menuShouldScrollIntoView={menuShouldScrollIntoView}
					menuPlacement="auto"
					menuPortalTarget={document.querySelector("body")}
				/>
			</div>

			<style>{`
		  .labelWithImage{
				height: 20px;
				width: 20px;
				margin-right: 5px;
		  }
		  .labelWithIcon{
				marhin-right: 5px;
		  }
		`}</style>
		</>
	);
};

export default DropdownWithIcon; 
